import { AppRouter } from "@modules/shell/client";

export function App() {
    return <AppRouter />;
}
